import React from "react";
import css from "./IntroductionView.module.css";
import {BlogView} from "Components";


export default function IntroductionView(props={}){
    const {}=props;
    return (
        <BlogView sections={statics.sections}/>
    )
}

const statics={
    sections:[
        {
            title:"What is Vritra ?",
            text:`
                Vritra serves as a JavaScript library specifically designed for constructing 
                user interfaces (UI) using only VanillaJS.
                @However, it goes beyond being just a library and can be considered as an approach or 
                methodology for developing hybrid-web applications.
                @The Vritra package itself acts as a valuable tool, streamlining the development process 
                and aiding in the realization of this approach.
            `,
        },
        {
            title:"Why use it ?",
            text:`
                Why choose it over other frameworks ?
                @Progressive web apps (PWAs) are often optimized for either Android or iOS platforms, targeting 
                small mobile devices with limited hardware capabilities. This can result in lower performance 
                and a subpar user experience due to the increased workload.
                @While libraries like React may perform well on desktop platforms, they may not meet 
                expectations when it comes to hybrid-web-based apps. To address this, Vritra offers a library
                that enables developers to build web-based apps in a React-Redux-like environment.
                @Vritra aims to provide a solution specifically tailored for hybrid-web applications, ensuring 
                better performance and an improved user experience.
            `,
            notice:`
                The statements above were derived from personal experiences. 
                @Ultimately, the decision to choose one approach over another or one framework 
                over another is entirely up to you.
            `,
        },
    ],
}
